// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox__checkboxWrapper","checkboxLabel":"Checkbox__checkboxLabel","checkboxDisabled":"Checkbox__checkboxDisabled"};